import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

const colorOptions = [
  { value: 'bg-blue-500', label: 'Mavi' },
  { value: 'bg-pink-500', label: 'Pembe' },
  { value: 'bg-amber-500', label: 'Amber' },
  { value: 'bg-green-500', label: 'Yeşil' },
  { value: 'bg-purple-500', label: 'Mor' },
  { value: 'bg-emerald-500', label: 'Zümrüt' },
  { value: 'bg-orange-500', label: 'Turuncu' },
  { value: 'bg-slate-600', label: 'Gri' },
  { value: 'bg-red-500', label: 'Kırmızı' },
  { value: 'bg-cyan-500', label: 'Turkuaz' },
  { value: 'bg-teal-600', label: 'Teal' },
  { value: 'bg-cyan-600', label: 'Cyan' },
];

const CategoriesTab = ({ settings, updateCategory }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Kategori Kartları</CardTitle>
        <CardDescription>Ana sayfada görünen kategori kartlarını düzenleyin</CardDescription>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {settings.categories?.map((cat, index) => (
            <div key={cat.id} className="border rounded-lg p-4">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-lg ${cat.color} flex items-center justify-center`}>
                    <span className="text-white text-sm">{cat.name?.charAt(0)}</span>
                  </div>
                  <span className="font-medium">{cat.name}</span>
                </div>
                <Switch
                  checked={cat.enabled}
                  onCheckedChange={(v) => updateCategory(index, 'enabled', v)}
                />
              </div>
              
              <div className="grid md:grid-cols-3 gap-3">
                <div className="space-y-1">
                  <Label className="text-xs">İsim</Label>
                  <Input
                    value={cat.name}
                    onChange={(e) => updateCategory(index, 'name', e.target.value)}
                    className="h-8 text-sm"
                  />
                </div>
                <div className="space-y-1">
                  <Label className="text-xs">Link</Label>
                  <Input
                    value={cat.link}
                    onChange={(e) => updateCategory(index, 'link', e.target.value)}
                    className="h-8 text-sm"
                  />
                </div>
                <div className="space-y-1">
                  <Label className="text-xs">Resim URL</Label>
                  <Input
                    value={cat.image}
                    onChange={(e) => updateCategory(index, 'image', e.target.value)}
                    className="h-8 text-sm"
                  />
                </div>
              </div>

              <div className="mt-2">
                <Label className="text-xs">Renk</Label>
                <div className="flex gap-1 mt-1">
                  {colorOptions.map((opt) => (
                    <button
                      key={opt.value}
                      onClick={() => updateCategory(index, 'color', opt.value)}
                      className={`w-6 h-6 rounded ${opt.value} border-2 ${
                        cat.color === opt.value ? 'border-black' : 'border-transparent'
                      }`}
                      title={opt.label}
                    />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default CategoriesTab;
